import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class FreespinRequestPayload extends RequestPayload {
}
